import React, { Component } from 'react'
import Projectdetail from './Projectdetail'
import Imagerow from './components/Imagerow'
import Updates from './components/Projupdates'

export class Envirogreen extends Component {

  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/screenshots/lrg/architectural-design-architecture-contemporary-1884256.jpg"
          heading="Envirogreen Reality"
          content={[
            <>
              <p>
                This A very simple, fictional Real Estate site, complete with
                searching capabilities, and a small admin cms, which has full
                CRUD capabilities. The front-end is simply HTML/CSS using the
                BootStrap framework. And a small bit of JavaScript, mainly to
                handle the AJAX search, on the homepage.
              </p>

              <p>
                The back-end however was built using the Laravel 5 PHP
                framework, and uses a MySQL database. The Admin CMS allows users
                to create, update, and delete rental listings, as well as the
                same for staff.
              </p>
            </>,
          ]}
          website="http://www.mlmontheweb.com/projects/envirogreen/"
          github="https://github.com/Jimmyelvis/envirogreen"
          techs={[
            <>
              <li>Laravel</li>
              <li>PHP</li>
              <li>JavaScript</li>
              <li>Ajax</li>
            </>,
          ]}
          updates={[
            <>
              <h2 className="heading-2">Recent Updates</h2>

              <div className="updates">
                <Updates
                  heading="UPDATE 2/10/2022"
                  desc={[
                    <>
                      <p>
                        Made some minor changes to the design of the site to a
                        more cleaner modern look.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/home-envirogreen.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/home-envirogreen.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/fdhdh.jpg",
                      screenshot: "assets/img/screenshots/lrg/fdhdh.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/retetetreter.jpg",
                      screenshot: "assets/img/screenshots/lrg/retetetreter.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/fdsfsffreeg.jpg",
                      screenshot: "assets/img/screenshots/lrg/fdsfsffreeg.jpg",
                    },
                  ]}
                  gallery="UPDATE 2/10/2022"
                />
              </div>
            </>,
          ]}
          images={[
            <>
              <Imagerow images="assets/img/screenshots/lrg/0e6d4b8f-0b03-49f5-a684-2fa41b8b3a8b.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/ccd435bf-584a-4591-8128-b2525a211d3e.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/0e6d4b8f-0b03-49f5-a684-2fa41b8b3a8b.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/ae1bf22d-726b-412b-9ac6-d4415db1c47e.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/66e2201b-d67e-45a3-ac14-4f977f019d50.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/209f303a-1618-49f7-a77a-cf645bd589aa.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/ae1bf22d-726b-412b-9ac6-d4415db1c47e.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/00181c0a-7262-4630-a5fe-9a21cb2cd177.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/0e6d4b8f-0b03-49f5-a684-2fa41b8b3a8b.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/33b50475-a5a4-4aa6-8585-c7b285ac4756.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/84435f0b-8f20-4515-8d19-2b762e97780d.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/d593ddd3-81ca-47b1-a36c-2155ee70ed4e.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/ccd435bf-584a-4591-8128-b2525a211d3e.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/57f01b78-9ce9-4bb3-934e-6206263e65e6.jpg" />
            </>,
          ]}
          style={{
            backgroundColor: "rgb(22 39 34)",
            opacity: "0.6",
          }}
        />
      </React.Fragment>
    );
  }
}

export default Envirogreen
